export enum CartSyncTracingMessages {
  CAPABILITY = 'orders',
  CART_SYNC = 'Cart Sync Process',
}
